export const imageLink = {
    profilePics: '/images/profile-pic.png',
    profilePics2: '/images/profile-pic2.png',
    blob: '/images/blob.png',
    blob1: '/images/blob1.png',
    blob2: '/images/blob2.png',
    il1: '/images/il1.jpg',
    il1_P:'/images/il1-P.png',
    paymentControle: '/images/projects/switch/Home.jpg',
    switchProject1: '/images/projects/supermart/project1.svg',
    paas: '/images/projects/paas/Login.jpg',
    supermart: '/images/projects/supermart/supermart2.png',
    switch1: '/images/projects/switch/Limits_1.jpg',
    profiPoint: '/images/projects/profpoint.png',
    paytelstack: '/images/projects/paytelstack/dashboard-overview.png',
}

export const projectGallery = {
    paytelstack: [
        '/images/projects/paytelstack/landing-hero.png',
        '/images/projects/paytelstack/landing-features.png',
        '/images/projects/paytelstack/landing-getting-started.png',
        '/images/projects/paytelstack/landing-pricing.png',
        '/images/projects/paytelstack/landing-testimonials.png',
        '/images/projects/paytelstack/landing-api-docs.png',
        '/images/projects/paytelstack/auth-login.png',
        '/images/projects/paytelstack/dashboard-overview.png',
        '/images/projects/paytelstack/dashboard-analytics.png',
        '/images/projects/paytelstack/dashboard-buy-airtime.png',
        '/images/projects/paytelstack/dashboard-transactions.png',
        '/images/projects/paytelstack/dashboard-wallet.png',
        '/images/projects/paytelstack/dashboard-fund-wallet-modal.png',
        '/images/projects/paytelstack/dashboard-transaction-details.png',
        '/images/projects/paytelstack/settings-payment-gateways.png',
        '/images/projects/paytelstack/settings-appearance.png',
    ],
    Fraud_management: [
        '/images/projects/switch/Home.jpg',
        '/images/projects/switch/Dashboard.jpg',
        '/images/projects/switch/Limits.jpg',
        '/images/projects/switch/Limits_1.jpg',
        '/images/projects/switch/Transactions.jpg',
    ],
    Supermart_express: [
        '/images/projects/supermart/supermart2.png',
        '/images/projects/supermart/supermart.png',
        '/images/projects/supermart/supermart1.png',
        '/images/projects/supermart/project1.svg',
    ],
    paas: [
        '/images/projects/paas/Login.jpg',
        '/images/projects/paas/Login_1.jpg',
        '/images/projects/paas/Dashboard (1).jpg',
        '/images/projects/paas/Banks List.jpg',
        '/images/projects/paas/Channel Monitoring.jpg',
        '/images/projects/paas/Audit.jpg',
    ],
    Payment_control: [
        '/images/projects/switch/Limits_1.jpg',
        '/images/projects/switch/Home.jpg',
        '/images/projects/switch/Dashboard.jpg',
        '/images/projects/switch/Limits.jpg',
        '/images/projects/switch/Transactions.jpg',
    ],
}